import React, { useState } from "react";
import AdminHeader from "./AdminHeader";
import AdminNavbar from "./AdminNavbar";
import { Link } from "react-router-dom";
const Achecksportwiseresult = () => {
  const [activeButton, setActiveButton] = useState(null);

  const handleClick = (buttonIndex) => {
    setActiveButton(buttonIndex);
  };

  const getButtonStyles = (buttonIndex) => {
    return `border border-gray-400 rounded px-4 py-2 mr-2 ${
      activeButton === buttonIndex ? "bg-white text-black" : ""
    } `;
  };

  return (
    <div className="fixed_width">
      <AdminHeader />
      <AdminNavbar />
      <div className="commision h-auto   bg-[#f0ece1]  ">
        <div className="flex-col flex justify-center ">
          <h2 className="font-bold mt-4  text-black px-[40px]">Check Result</h2>
          <div className="flex  justify-center">
            <div className="commision_bos mt-4 bg-[#c6ebffc9] border-b-2 shadow-sm border-blue-300 w-[98%] px-5 py-3">
              <label htmlFor="" className="mr-2">
                Period
              </label>
              <input
                type="date"
                id="birthday"
                className="py-2 px-2 shadow-sm"
                name="birthday"
              ></input>
              <label for="birthday">To</label>
              <input
                type="date"
                className="py-2 px-2 shadow-sm ml-3"
                id="birthday"
                name="birthday"
              ></input>
              <button className="bg-yellow-500 mr-2 rounded text-black font-bold py-1 px-3">
                Cricket
              </button>
              <button className="bg-yellow-500 mr-2 rounded text-black font-bold py-1 px-3">
                Soccer
              </button>
              <button className="bg-yellow-500 mr-2 rounded text-black font-bold py-1 px-3">
                Tennis
              </button>
              <button className="bg-yellow-500 mr-2 rounded text-black font-bold py-1 px-3">
                Vertual Id
              </button>
            </div>
          </div>
          <div>
            <div className="restore mt-3 p-3  ">
              <div className="restore_indisde_heading flex justify-end rounded-md w-[95%] ">
                <input
                  type="search"
                  className="px-2 w-[250px] border-1 border-gray-400 py-2"
                  placeholder="Search"
                />
              </div>
              <div className="flex flex-col">
                <div className="overflow-x-auto">
                  <div className="p-1.5 w-full inline-block align-middle">
                    <div className="overflow-hidden border border-black">
                      <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-black text-white">
                          <tr>
                            <th
                              scope="col"
                              className="px-6 py-3 text-xs font-bold text-left  uppercase "
                            >
                              S.No.
                            </th>
                            <th
                              scope="col"
                              className="px-6 py-3 text-xs font-bold text-left  uppercase "
                            >
                              Sport
                            </th>
                            <th
                              scope="col"
                              colSpan="1"
                              className="px-4 py-3 text-xs font-bold text-left  uppercase "
                            >
                              Match Date
                            </th>
                            <th
                              scope="col"
                              colSpan="3"
                              className="px-6 py-3 text-xs font-bold text-left  uppercase "
                            >
                              Match Name
                            </th>
                            <th
                              scope="col"
                              className="px-6 py-3 text-xs font-bold text-right  uppercase "
                            >
                              Winner
                            </th>
                          </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200">
                          <tr>
                            <td className="px-6 py-4 text-sm font-medium text-gray-800 whitespace-nowrap">
                              3
                            </td>
                            <td className="px-6 py-4 text-sm text-gray-800 whitespace-nowrap">
                              Jone Doe
                            </td>
                            <td className="px-4 py-4 text-sm text-gray-800 whitespace-nowrap">
                              jonne62@gmail.com
                            </td>
                            <td
                              colSpan="4"
                              className="px-6 py-4 text-sm font-medium text-right whitespace-nowrap"
                            >
                              <a
                                className="text-green-500 hover:text-green-700"
                                href="#"
                              >
                                Edit
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Achecksportwiseresult;
